import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { Tag } from '@otomoro/components/shared/Tag'
import { PortableText, PortableTextComponents, SanityImageAssetDocument } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { heroImageClasses, HeroImageVariants } from './HeroImage.css'

interface HeroImageProps extends HeroImageVariants {
	tag: string
	hero: PortableTextObject
	picture: SanityImageAssetDocument
}

export const HeroImage: React.FC<HeroImageProps> = ({ tag, hero, picture }) => {
	const components = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle
					as="strong"
					textTransform="uppercase"
					variant="h1"
					className="col-span-4 md:col-span-6 md:max-w-[70rem]"
					color="black"
				>
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	const { base, container, imageContainer, image } = heroImageClasses()

	return (
		<section className={base()}>
			<Tag>{tag}</Tag>
			<div className={container()}>
				<PortableText value={hero} components={components} />
				<div className={imageContainer()}>
					<SanityImage
						className={image()}
						image={picture.image}
						alt={picture.alt || ''}
						sizes='(max-width: 768px) 100vw, (max-width: 1200px) 60vw, 80vw'
					/>
				</div>
			</div>
		</section>
	)
}
